module.exports = __webpack_public_path__ + "static/media/1.2ad12891.JPG";